export default "__VITE_ASSET__0exprZYG__"